import * as React from 'react';

export const FormGroup: React.StatelessComponent<any> = (props) => {
    return (
        <div>
            {props.children}
        </div>
    );

}



// WEBPACK FOOTER //
// ./src/common/forms/FormGroup.tsx